import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=45ca585a&scoped=true"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"
import style0 from "./RolesTable.vue?vue&type=style&index=0&id=45ca585a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca585a",
  null
  
)

export default component.exports